import { useCurrentCompanyId, useCurrentUser } from "hooks/auth";
import { useMemo } from "react";
import { ClientPaths } from "./ClientPaths";
import { GuestPaths } from "./GuestPaths";
import { SupplierPaths } from "./SupplierPaths";
import { BaseMemberPaths } from "./navigation.types";
import { useCurrentUserHasDashboard } from "hooks/featureFlags";

export const useCurrentAccountPath = (): string => {
	const currentCompanyId = useCurrentCompanyId();
	const { isGuest } = useCurrentUser();

	if (isGuest) {
		return "/account/";
	}

	if (currentCompanyId) {
		return `/account/${currentCompanyId}`;
	}

	return "/member/login";
};

export const useClientAccountPaths = (): ClientPaths => {
	const currentCompanyId = useCurrentCompanyId();
	const hasDashboard = useCurrentUserHasDashboard();

	return useMemo(() => {
		return !currentCompanyId || isNaN(currentCompanyId)
			? null
			: new ClientPaths(currentCompanyId, hasDashboard);
	}, [currentCompanyId, hasDashboard]);
};

export const useGuestAccountPaths = (): GuestPaths => {
	const { isGuest } = useCurrentUser();

	return useMemo(() => {
		return isGuest ? new GuestPaths() : null;
	}, [isGuest]);
};

export const useSupplierAccountPaths = (): SupplierPaths => {
	const currentCompanyId = useCurrentCompanyId();

	return useMemo(() => {
		return !currentCompanyId || isNaN(currentCompanyId)
			? null
			: new SupplierPaths(currentCompanyId);
	}, [currentCompanyId]);
};

export const useMemberPaths = (): BaseMemberPaths => {
	const currentCompanyId = useCurrentCompanyId();

	return useMemo(() => {
		return !currentCompanyId || isNaN(currentCompanyId)
			? null
			: new SupplierPaths(currentCompanyId);
	}, [currentCompanyId]);
};
